import React from "react";
import { HiOutlineMail as MailIcon } from "react-icons/hi";
import { FaPhone, FaGithub, FaLinkedin } from "react-icons/fa";

export const Footer = () => {
  return (
    <div className="bg-cyber-black w-full py-12 px-6 border-t border-cyber-green/10 flex flex-col items-center justify-center relative">
      <div className="max-w-5xl w-full flex flex-col md:flex-row justify-between items-center gap-8">
        
        {/* Left Side Info */}
        <div className="text-center md:text-left space-y-2">
          <p className="font-mono text-xs text-cyber-green uppercase tracking-[0.2em]">
            // PERSISTENT_WARRIOR_PROTOCOL
          </p>
          <p className="text-sm text-cyber-gray-400 font-sans">
            Designed and engineered by Alok Singh. All rights reserved.
          </p>
        </div>

        {/* Right Side Icons */}
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 w-full md:w-auto font-mono text-xs">
          
          {/* Phone */}
          <div className="flex items-center space-x-2 bg-cyber-darker p-3 rounded-lg border border-cyber-gray-800 hover:border-cyber-green/50 transition duration-300">
            <FaPhone className="text-cyber-green" />
            <span id="contact-phone" className="text-white text-[11px]">+918318739431</span>
          </div>

          {/* Linkedin */}
          <a
            id="contact-linkedin"
            href="https://www.linkedin.com/in/aloksingh9/"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center space-x-2 bg-cyber-darker p-3 rounded-lg border border-cyber-gray-800 hover:border-cyber-blue/50 transition duration-300"
          >
            <FaLinkedin className="text-cyber-blue" />
            <span className="text-white text-[11px]">LinkedIn</span>
          </a>

          {/* Github */}
          <a
            id="contact-github"
            href="https://github.com/aloki9singh"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center space-x-2 bg-cyber-darker p-3 rounded-lg border border-cyber-gray-800 hover:border-cyber-gray-300/50 transition duration-300"
          >
            <FaGithub className="text-cyber-gray-300" />
            <span className="text-white text-[11px]">GitHub</span>
          </a>

          {/* Email */}
          <a
            id="contact-email"
            href="mailto:kshatriyaalok1997@gmail.com"
            className="flex items-center space-x-2 bg-cyber-darker p-3 rounded-lg border border-cyber-gray-800 hover:border-cyber-green/50 transition duration-300"
          >
            <MailIcon className="text-cyber-green" />
            <span className="text-white text-[10px]">Email</span>
          </a>

        </div>

      </div>

      <div className="mt-8 font-mono text-[10px] text-cyber-gray-600">
        ALOK_SINGH // SYSTEM_OK
      </div>
    </div>
  );
};
